import { useEffect } from "react";
import { BrowserRouter, Routes, Route, Outlet, Navigate, useLocation, useParams } from "react-router-dom";
import Header from "./components/Header";
import Footer from "./components/Footer";
import AdminLayout from "./components/AdminLayout";
import TrackPageview from "./components/TrackPageview";
import HomePage from "./pages/HomePage";
import CategoriesPage from "./pages/CategoriesPage";
import CategoryDetailPage from "./pages/CategoryDetailPage";
import ProductDetailPage from "./pages/ProductDetailPage";
import NotFoundPage from "./pages/NotFoundPage";
import ProductsPage from "./pages/ProductsPage";
import AboutPage from "./pages/AboutPage";
import DeliveriesPage from "./pages/DeliveriesPage";
import DeliveryDetailPage from "./pages/DeliveryDetailPage";
import ContactPage from "./pages/ContactPage";
import LoginPage from "./pages/LoginPage";
import AdminPage from "./pages/AdminPage";
import AdminContactPage from "./pages/AdminContactPage";
import AdminCategoryPage from "./pages/AdminCategoryPage";
import AdminProductsPage from "./pages/AdminProductsPage";
import AdminDeliveriesPage from "./pages/AdminDeliveriesPage";
import AdminFormPage from "./pages/AdminFormPage";
import AdminAdminsPage from "./pages/AdminAdminsPage";
import AdminActivitiesPage from "./pages/AdminActivitiesPage";

function LegacyCategoryRedirect() {
  const { slug } = useParams();
  return <Navigate to={slug ? `/category/${slug}` : "/category"} replace />;
}

function shouldScrollToContactForm(location) {
  const hash = String(location.hash || "");
  if (hash === "#contact-form" || hash === "#send-an-enquiry") return true;
  return new URLSearchParams(location.search || "").get("intent") === "quote";
}

function ScrollToTop() {
  const location = useLocation();

  useEffect(() => {
    if ("scrollRestoration" in window.history) {
      window.history.scrollRestoration = "manual";
    }
  }, []);

  useEffect(() => {
    if (shouldScrollToContactForm(location)) return;
    window.scrollTo(0, 0);
  }, [location]);

  return null;
}

function PublicLayout() {
  return (
    <div className="flex min-h-screen flex-col">
      <ScrollToTop />
      <TrackPageview />
      <Header />
      <main className="flex-1">
        <Outlet />
      </main>
      <Footer />
    </div>
  );
}

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/login" element={<LoginPage />} />
        <Route element={<PublicLayout />}>
          <Route path="/" element={<HomePage />} />
          <Route path="/products" element={<ProductsPage />} />
          <Route path="/category" element={<CategoriesPage />} />
          <Route path="/category/:slug" element={<CategoryDetailPage />} />
          <Route path="/category/:categorySlug/:productSlug" element={<ProductDetailPage />} />
          <Route path="/products/category" element={<Navigate to="/category" replace />} />
          <Route path="/products/category/:slug" element={<LegacyCategoryRedirect />} />
          <Route path="/about" element={<AboutPage />} />
          <Route path="/deliveries" element={<DeliveriesPage />} />
          <Route path="/deliveries/:dateStamp/:slug" element={<DeliveryDetailPage />} />
          <Route path="/deliveries/:slug" element={<DeliveryDetailPage />} />
          <Route path="/contact" element={<ContactPage />} />
          <Route path="/contact-us" element={<Navigate to="/contact" replace />} />
          <Route path="*" element={<NotFoundPage />} />
        </Route>
        <Route element={<AdminLayout />}>
          <Route path="/admin" element={<AdminPage />} />
          <Route path="/admin-activities" element={<AdminActivitiesPage />} />
          <Route path="/admin-category" element={<AdminCategoryPage />} />
          <Route path="/admin-products" element={<AdminProductsPage />} />
          <Route path="/admin-deliveries" element={<AdminDeliveriesPage />} />
          <Route path="/admin-form" element={<AdminFormPage />} />
          <Route path="/admin-contact" element={<AdminContactPage />} />
          <Route path="/admins" element={<AdminAdminsPage />} />
        </Route>
      </Routes>
    </BrowserRouter>
  );
}

export default App;
